import React, {memo} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {getRoomContext} from 'middleware/analytics/selectors'
import {getUserCountryCode} from 'modules/meta/selectors'
import {showRoomDetailsOverlay} from 'modules/overlay/actions'

import {Divider} from '@daedalus/atlas/Divider'
import {ContentWrapper} from '@daedalus/atlas/helpers/ContentWrapper'
import {RoomInfo} from '@daedalus/shared/src/accommodation/RoomInfo'

import {FrozenRoomOffer} from '../../FrozenRoomOffer'
import {RoomOffersList} from '../../RoomOffersList/RoomOffersList'
import {RoomCardVariant} from '../../RoomVariant/RoomCardVariant'
import {RoomDetailsMountComponent} from '../constants'
import {RoomCardGallery} from '../RoomCardGallery'

import type {RoomCardPropsType} from '../types'

export const RoomCardMobile = memo(
  ({hotelId, room, variant, isFrozen}: RoomCardPropsType) => {
    const noRoomImage = room.images.length === 0
    const dispatch = useDispatch()
    const userCountry = useSelector(getUserCountryCode)

    const onOpenRoomDetailsOverlay = () => {
      dispatch(showRoomDetailsOverlay({roomId: room.id, hotelId}))
    }
    const roomContext = useSelector(state => getRoomContext(state, room.id))

    const isDetailsLinkVisible =
      room.description?.length > 0 ||
      room.amenities?.length > 0 ||
      room.images?.length > 0

    return (
      <RoomCardVariant variant={variant}>
        <RoomCardGallery
          onOpenRoomDetailsOverlay={onOpenRoomDetailsOverlay}
          room={room}
        />
        <ContentWrapper
          padding="s500"
          paddingTop={noRoomImage ? 's500' : 's400'}
        >
          <RoomInfo
            room={room}
            onOpenRoomDetailsOverlay={onOpenRoomDetailsOverlay}
            isTruncatedLongName
            isDetailsLinkVisible={isDetailsLinkVisible}
            userCountry={userCountry}
          />
        </ContentWrapper>
        {/* Details slot */}
        <Divider />
        <ContentWrapper padding="s500">
          {isFrozen ? (
            <FrozenRoomOffer
              hotelId={hotelId}
              room={room}
              roomContext={roomContext}
            />
          ) : (
            <RoomOffersList
              hotelId={hotelId}
              room={room}
              component={RoomDetailsMountComponent.HotelViewRoomsSection}
              roomContext={roomContext}
            />
          )}
        </ContentWrapper>
      </RoomCardVariant>
    )
  }
)
RoomCardMobile.displayName = 'RoomCardMobile'
